import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ambil, simpanan, segarkan } from "../lib/prefetch";
import { mediaUrl, logoUrl } from "../lib/media";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import { AnnouncementBar } from "../components/home/AnnouncementBar";
import { BannerLink } from "../components/home/BannerLink";
import { KartuProdukHp } from "./KartuProdukHp";
import { MenuBawah } from "./MenuBawah";
import { ToastHp } from "./ToastHp";
import { FooterHp } from "./FooterHp";
import { useTambah } from "./useTambah";
import { asalNavigasiHp } from "./navigasiHp";
import { IkonCari, IkonKeranjang, IkonTruk, IkonPerisai, IkonLabel, IkonKotak, Bintang as BintangIkon } from "./Ikon";
import "./hp.css";
import { useChat, lencanaChat, ariaChat } from "../chat/chatKonteks";
import { IkonGelembung } from "../chat/IkonChat";

// Beranda HP = papan B1d "Beranda, kepala putih logo saja". Banner utama, pengumuman, ulasan = isian admin seperti sebelumnya.
// Banner kecil Halaman Depan hanya di layar komputer (Papan 3, 25/10/2026). Banner tengah tampil di HP sejak INSTRUKSI 30/10/2026 v3 (papan B1e):
// di antara Produk Terlaris dan Semua Produk, rasio gambar HP 1122:320. Semua Produk = 8 kartu
// (INSTRUKSI 30/10/2026 butir B; sebelumnya 4 kartu papan B1d).
const JUMLAH_SEMUA = 8;
const KEUNGGULAN = [
  { Ikon: IkonTruk, teks: "Gratis Ongkir" },
  { Ikon: IkonPerisai, teks: "Kualitas Terjamin" },
  { Ikon: IkonLabel, teks: "Harga Grosir" },
  { Ikon: IkonKotak, teks: "Stok Siap Kirim" },
];
// Kecepatan geser ulasan (piksel per detik) dari isian "Kecepatan ulasan" di admin
const PX_PER_DETIK = { LAMBAT: 28, SEDANG: 42, CEPAT: 64 };

export function KepalaBerandaHp({ settings }) {
  const chat = useChat();
  const lokasi = useLocation();
  const { user } = useAuth();
  const { count } = useCart();
  const namaToko = settings?.nama_toko || "Hoonstore";
  return (
    <header className="hp-kepala" data-testid="hp-kepala">
      <Link to="/" className="hp-kepala__logo" data-testid="nav-brand-logo">
        <img src={logoUrl(settings?.logo_url)} alt={namaToko} width="600" height="80" />
      </Link>
      <Link to="/katalog" aria-label="Cari produk" className="hp-ikon-tombol" data-testid="hp-kepala-cari">
        <span><IkonCari /></span>
      </Link>
      {chat.aktif && user?.role !== "admin" && (
        <button type="button" aria-label={ariaChat(chat.belum_dibaca)} className="hp-ikon-tombol" data-testid="hp-kepala-chat" onClick={() => chat.buka(null)}>
          <span><IkonGelembung ukuran={22} /></span>
          {lencanaChat(chat.belum_dibaca) && <span className="hp-badge" aria-hidden="true" data-testid="hp-kepala-chat-lencana">{lencanaChat(chat.belum_dibaca)}</span>}
        </button>
      )}
      {user?.role !== "admin" && (
        <Link to={user ? "/keranjang" : "/login"} state={{ ...asalNavigasiHp(lokasi), ...(!user ? { from: "/keranjang" } : {}) }} aria-label={`Keranjang, ${count} produk`} className={`hp-ikon-tombol${count > 0 ? " is-terisi" : ""}`} data-testid="hp-kepala-keranjang">
          <span><IkonKeranjang /></span>
          {count > 0 && <span className="hp-badge">{count}</span>}
        </Link>
      )}
    </header>
  );
}

function HeroHp({ slides }) {
  const list = (slides || []).filter((s) => s?.gambar || s?.gambar_hp);
  const n = list.length;
  const ref = useRef(null);
  const [i, setI] = useState(0);
  const [jeda, setJeda] = useState(false);
  const lanjut = useRef(null);   // jeda sesudah disentuh; dibatalkan bila disentuh lagi / halaman ditutup
  useEffect(() => () => clearTimeout(lanjut.current), []);

  useEffect(() => {
    if (n <= 1 || jeda) return undefined;
    const t = setInterval(() => {
      const el = ref.current;
      if (!el || !el.clientWidth) return;
      const berikut = (Math.round(el.scrollLeft / el.clientWidth) + 1) % n;
      el.scrollTo({ left: berikut * el.clientWidth, behavior: "smooth" });
    }, 4000);
    return () => clearInterval(t);
  }, [n, jeda]);

  if (!n) return null;
  const onScroll = (e) => {
    const el = e.currentTarget;
    const k = el.clientWidth ? Math.round(el.scrollLeft / el.clientWidth) : 0;
    if (k !== i) setI(k);
  };
  return (
    <section className="hp-hero" data-testid="hero-carousel">
      <div ref={ref} className="hp-hero__jalur" onScroll={onScroll}
        onTouchStart={() => { clearTimeout(lanjut.current); setJeda(true); }}
        onTouchEnd={() => { clearTimeout(lanjut.current); lanjut.current = setTimeout(() => setJeda(false), 4000); }}>
        {list.map((s, k) => {
          const src = mediaUrl(s.gambar_hp || s.gambar_960 || s.gambar);
          const mini = s.gambar_hp_mini || s.gambar_mini || "";
          return (
            <BannerLink key={k} href={s.href} className="hp-hero__slide" tid={`hero-slide-${k}`}>
              {mini ? <span aria-hidden="true" className="hp-hero__mini" style={{ backgroundImage: `url(${mini})` }} /> : null}
              <img src={src} alt={s.alt || ""} width="1470" height="735" loading={k === 0 ? "eager" : "lazy"}
                fetchPriority={k === 0 ? "high" : "auto"} decoding={k === 0 ? "sync" : "async"} className="hp-hero__img hero-img" />
            </BannerLink>
          );
        })}
      </div>
      {n > 1 && (
        <div aria-hidden="true" className="hp-hero__titik" data-testid="hero-dots">
          {list.map((_, k) => <span key={k} className={k === i ? "is-aktif" : ""} />)}
        </div>
      )}
    </section>
  );
}

// Banner tengah HP (INSTRUKSI 30/10/2026 v3 butir A): sejajar kotak Semua Produk, tinggi = rasio 1122:320, gambar HP atau gambar desktop
// ukuran 960. Tanpa gambar → tidak tampil sama sekali (sama dengan komputer).
function BannerTengahHp({ banner }) {
  if (!banner || (!banner.gambar && !banner.gambar_hp)) return null;
  const src = banner.gambar_hp || banner.gambar_960 || banner.gambar;
  return (
    <section className="hp-banner-tengah" data-testid="hp-banner-tengah">
      <BannerLink href={banner.href} className="hp-banner-tengah__tautan" tid="hp-banner-tengah-link">
        {/* alt kosong pada banner yang bisa diklik → tautan tanpa nama untuk pembaca layar; beri nama umum */}
        <img src={mediaUrl(src)} alt={banner.alt || (banner.href ? "Banner promo" : "")} width="1122" height="320" loading="lazy" decoding="async" />
      </BannerLink>
    </section>
  );
}

// PR banner geser HP (INSTRUKSI 02/11/2026, mockup versi C; keputusan Haryanto 1–5): deretan slide 1280:500 yang HANYA digeser pembeli (tanpa
// pindah otomatis, tanpa titik), kartu berikutnya mengintip di kanan (86% lebar), satu slide = selebar penuh. Judul dari admin (kosong = tanpa
// judul). Slide pertama dimuat biasa, sisanya lazy; srcset 640/1280; width/height diisi supaya tata letak tidak meloncat.
// review Codex 1: lebar sebenarnya dari nama berkas olahan ("…-1280.webp", "…-640.webp"); berkas yang disimpan apa adanya tidak punya lebar di
// namanya → tanpa srcset (src saja), supaya peramban tidak diberi lebar yang salah
const lebarBerkas = (p) => { const m = /-(\d{2,4})\.webp$/.exec(String(p || "")); return m ? Number(m[1]) : 0; };
export const slideGeserTampil = (konten) => (Array.isArray(konten?.banner_geser_hp) ? konten.banner_geser_hp : []).filter((s) => s && (s.gambar || s.gambar_hp));
export function BannerGeserHp({ judul, slides }) {
  const satu = slides.length === 1;
  return (
    <section className="hp-geser-promo" data-testid="hp-banner-geser">
      {judul ? <h2 className="hp-judul hp-geser-promo__judul" data-testid="hp-banner-geser-judul">{judul}</h2> : null}
      <div className={`hp-geser-promo__deret${satu ? " is-satu" : ""}`} role="region" aria-label={judul || "Promo"} tabIndex={satu ? undefined : 0}
        data-testid="hp-banner-geser-deret">
        {slides.map((s, i) => {
          const besar = s.gambar || s.gambar_hp, kecil = s.gambar_hp;
          const lb = lebarBerkas(s.gambar), lk = lebarBerkas(kecil);
          return (
            <BannerLink key={i} href={s.href} className="hp-geser-promo__kartu" tid={`hp-banner-geser-${i}`}>
              <img src={mediaUrl(besar)} srcSet={kecil && s.gambar && lb && lk && lk < lb ? `${mediaUrl(kecil)} ${lk}w, ${mediaUrl(s.gambar)} ${lb}w` : undefined}
                sizes={satu ? "calc(100vw - 16px)" : "86vw"} width="1280" height="500" alt={s.alt || (s.href ? "Banner promo" : "")}
                loading={i === 0 ? undefined : "lazy"} decoding="async" draggable="false" />
            </BannerLink>
          );
        })}
      </div>
    </section>
  );
}

function StripKeunggulan() {
  const isi = (sembunyi) => (
    <div className="hp-strip__grup" aria-hidden={sembunyi || undefined}>
      {KEUNGGULAN.map(({ Ikon, teks }) => (
        <span key={teks} className="hp-strip__item"><Ikon ukuran={14} />{teks}</span>
      ))}
    </div>
  );
  return (
    <div className="hp-strip" data-testid="advantage-strip">
      <div className="hp-strip__mask">
        <div className="hp-strip__jalan hp-geser">{isi(false)}{isi(true)}</div>
      </div>
    </div>
  );
}

function Bintang({ n }) {
  return (
    <div role="img" aria-label={`${n} dari 5 bintang`} className="hp-bintang">
      {[1, 2, 3, 4, 5].map((k) => <BintangIkon key={k} penuh={k <= n} />)}
    </div>
  );
}

function UlasanHp({ ulasan, kecepatan }) {
  const list = ulasan || [];
  if (!list.length) return null;
  const laju = PX_PER_DETIK[String(kecepatan || "LAMBAT").toUpperCase()] || PX_PER_DETIK.LAMBAT;
  const durasi = Math.max(12, Math.round((list.length * 226) / laju));
  const kartu = (u, dup) => (
    <article key={`${dup ? "d" : "u"}-${u.id}`} className="hp-ulasan__kartu" aria-hidden={dup || undefined} data-testid={dup ? undefined : `ulasan-card-${u.id}`}>
      <Bintang n={u.bintang} />
      <p>{u.teks}</p>
      <span className="hp-ulasan__nama"><b>{u.nama}</b>{u.kota ? ` · ${u.kota}` : ""}</span>
    </article>
  );
  return (
    <section className="hp-ulasan" data-testid="testimonials">
      <h2 className="hp-judul hp-judul--tengah" data-testid="testimonials-title">Apa Kata Pelanggan Kami</h2>
      <div className="hp-ulasan__mask">
        <div className="hp-ulasan__jalan hp-geser" style={{ animationDuration: `${durasi}s` }}>
          <div className="hp-ulasan__grup">{list.map((u) => kartu(u, false))}</div>
          <div className="hp-ulasan__grup" aria-hidden="true">{list.map((u) => kartu(u, true))}</div>
        </div>
      </div>
    </section>
  );
}

export default function BerandaHp({ slides, kepalaHero, pengumuman, konten, terlaris, ulasan, settings }) {
  const { tambahKartu, sibuk } = useTambah();
  const [semua, setSemua] = useState(() => simpanan("/api/products") || null);

  useEffect(() => {
    let batal = false;
    // PR46 tambahan 29/10/2026: jawaban disimpan di memori (lib/prefetch) → Katalog "Semua" langsung tampil tanpa kotak abu-abu
    segarkan("/api/products").then((data) => { if (!batal) setSemua(data || []); }).catch(() => { if (!batal) setSemua((s) => s || []); });
    return () => { batal = true; };
  }, []);

  // PR46 tambahan 29/10/2026: sesudah beranda tampil, saat browser senggang, muat lebih dulu kode halaman Katalog & Produk (potongan yang
  // sama dengan lazy() di App.js) dan daftar kategori
  useEffect(() => {
    const muat = () => {
      import("../pages/Catalog").catch(() => {});
      import("../pages/ProductDetail").catch(() => {});
      ambil("/api/kategori").catch(() => {});
    };
    if (typeof window.requestIdleCallback === "function") {
      const id = window.requestIdleCallback(muat, { timeout: 3000 });
      return () => window.cancelIdleCallback?.(id);
    }
    const t = setTimeout(muat, 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="hp hp--menu" data-testid="hp-beranda">
      {pengumuman ? <div className="hsv5"><AnnouncementBar konten={pengumuman} /></div> : null}
      <KepalaBerandaHp settings={settings} />
      {kepalaHero ? <div className="hsv5">{kepalaHero}</div> : <HeroHp slides={slides} />}
      <StripKeunggulan />

      {terlaris && terlaris.length > 0 && (
        <section className="hp-terlaris" data-testid="best-sellers">
          <div className="hp-baris-judul">
            <h2 className="hp-judul">Produk Terlaris</h2>
            <Link to="/katalog" className="hp-tautan-kecil" data-testid="hp-terlaris-lihat-semua">Lihat Semua ›</Link>
          </div>
          <div className="hp-geser-x">
            {terlaris.map((p, k) => <KartuProdukHp key={p.id} p={p} tambahKartu={tambahKartu} sibuk={sibuk} geser eager={k < 2} peringkat={p.terlaris_beranda || null} />)}
          </div>
        </section>
      )}

      {/* PR banner geser HP: ≥ 1 slide → Banner Geser menggantikan banner tengah di HP (komputer tidak berubah); 0 slide → banner tengah lama */}
      {slideGeserTampil(konten).length > 0
        ? <BannerGeserHp judul={String(konten?.banner_geser_hp_judul ?? "").trim()} slides={slideGeserTampil(konten)} />
        : <BannerTengahHp banner={konten?.banner_tengah} />}

      {semua && semua.length > 0 && (
        <section className="hp-semua" data-testid="hp-semua-produk">
          <h2 className="hp-judul hp-judul--semua">Semua Produk</h2>
          <div className="hp-grid">
            {semua.slice(0, JUMLAH_SEMUA).map((p) => <KartuProdukHp key={p.id} p={p} tambahKartu={tambahKartu} sibuk={sibuk} />)}
          </div>
          <Link to="/katalog" className="hp-lihat-semua" data-testid="hp-lihat-semua">Lihat Semua {semua.length} Produk ›</Link>
        </section>
      )}

      <UlasanHp ulasan={ulasan} kecepatan={konten?.ulasan_kecepatan} />
      <FooterHp konten={konten} settings={settings} />
      <ToastHp />
      <MenuBawah />
    </div>
  );
}
